import script from "./AddPodcastAdminCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPodcastAdminCampaign.vue?vue&type=script&setup=true&lang=js"

import "./AddPodcastAdminCampaign.vue?vue&type=style&index=0&id=47c1d21e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c1d21e"]])

export default __exports__